if (!customElements.get("m-custom-content-slider")) {
  class MCustomContentSlider extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.selectors = {
        slideControls: ".m-slider-controls",
        slideInner: ".swiper-wrapper",
      };
      this.classes = {
        swiper: 'swiper-container',
        swiperWrapper: 'swiper-wrapper'
      };
      this.domNodes = queryDomNodes(this.selectors, this);

      this.slider = false;

      this.showNavigation = this.dataset.showNavigation === "true";
      this.showPagination = this.dataset.showPagination === "true";
      this.defaultGap = parseInt(this.dataset.gap) || 30;
      this.gapMobile = parseInt(this.dataset.gapMobile) || 16;

      this.init();
    }

    init() {
      this.initSlider();
    }

    initSlider() {
      const { slideControls } = queryDomNodes(this.selectors, this);

      const prevButton = slideControls && slideControls.querySelector(".m-slider-controls__button-prev");
      const nextButton = slideControls && slideControls.querySelector(".m-slider-controls__button-next");

      this.options = {
        slidesPerView: 1.2,
        loop: false,
        slidesPerGroup: 1,
        showNavigation: this.showNavigation,
        showPagination: this.showPagination,
        pagination: this.showPagination
          ? {
              el: this.querySelector(".swiper-pagination"),
              clickable: true,
              bulletClass: "m-dot",
              bulletActiveClass: "m-dot--active",
              renderBullet: function (index, className) {
                return '<span class="' + className + '"></span>';
              },
            }
          : false,
        navigation: (nextButton || prevButton) && this.showNavigation ? {
          nextEl: nextButton && nextButton,
          prevEl: prevButton && prevButton
        } : false,
        breakpoints: {
          480: {
            slidesPerView: 1.5,
          },
          1024: {
            slidesPerView: 2,
          }
        }
      };

      if (typeof this.slider !== 'object') {
        this.slider = new MinimogLibs.Swiper(this, this.options);
      }
    }
  }

  customElements.define("m-custom-content-slider", MCustomContentSlider);
}
